module.exports = "query gifttyCatalog {\n  gifttyCatalog {\n    giftty_product_id\n    value\n    product_name\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/GifttyProducts.graphql
// module id = YANm
// module chunks = 1624